import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ProductSection from "@/components/ProductSection";
import { useProducts } from "@/hooks/useProducts";

const Shop = () => {
  const { products, loading, error } = useProducts();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-lg">Loading products...</div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-lg text-red-500">Error loading products: {error.message}</div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        <div className="bg-gradient-to-r from-cyan-600 via-blue-600 to-purple-600 py-12">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Shop All Products
            </h1>
            <p className="text-white/90 text-lg">
              Browse our complete collection of custom print-on-demand products
            </p>
          </div>
        </div>

        <ProductSection
          title="All Products"
          subtitle="Explore our full catalog"
          products={products}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Shop;
